import React from 'react';
import { Card, Col, Container, Row } from "react-bootstrap";
import { useNavigate } from 'react-router-dom';

export default function MarchSchedule() {
    const navigate  = useNavigate();
    const classes = [
        {
            image: "images/breadout.jpg",
            date: "MARCH 11",
            title: "Basics of Bread\n1 Day Hands-On Workshop",
            href:'/basic-of-bread'
        },
        
        {
            image: "images/cookie.webp",
            date: "MARCH 12",
            title: "Cookies\n1 Day Hands-On Workshop",
            href:'/cookies'
        },
        {
            image: "images/muffinout.jpg",
            date: "MARCH 13",
            title: "Muffins\n1 Day Hands-On Workshop",
            href:'/muffins'
        },
        {
            image: "images/travelcakeout.jpg",
            date: "MARCH 14",
            title: "Travel Cakes\n1 Day Hands-On Workshop",
            href:'/travelcake'
        },
        {
            image: "images/cupcakeout.jpg",
            date: "MARCH 17",
            title: "Cup Cakes\n1 Day Hands-On Workshop",
            href:'/cupcakes'
            
        },
        {
            image: "images/cookies.jpg",
            date: "MARCH 18",
            title: "Meringues & Macarons\n1 Day Hands-On Workshop",
           href:'/meringuesandmacarons'
        },
        {
            image: "images/puffout.jpg",
            date: "MARCH 19, 20, 21",
            title: "Puff Pastry and Artisan Breads\n3 Days Hands-On Workshop",
            href:'/puffpastry'
        },
        {
            image: "images/choux.webp",
            date: "MARCH 24",
            title: "Choux Pastry\n1 Day Hands-On Workshop",
            href:'/chouxpastry'
        },
        {
            image: "images/sweettartout.jpg",
            date: "MARCH 25",
            title: "Sweet Tarts\n1 Day Hands-On Workshop",
            href:'/sweettarts'
        },
        {
            image: "images/viennooutside.jpg",
            date: "MARCH 26, 27, 28",
            title: "Viennoiseries & Enriched Breads\n3 Days Hands-On Workshop",
            href:'/viennoiseriesandenrichedbreads'
        },
        
        
    ]
    const handleCardClick=(href) =>{
        navigate(href);
    }
    return (
        <>
            {/* <div className="aboutus_bg">
                <div className="aboutus-img-content">
                    <h1>November Schedule</h1>
                </div>
            </div> */}
            <div className='nov_class'>
            <div className="class-head" id="course">
                
                <div className="pop-class ">
                    <h3 style={{paddingTop:'3%',paddingBottom:'3%'}}>Whisk, Bake, and Create – March Schedule 2025 !</h3>
                    <Container>
                        <Row >
                            {classes.map((cls, index) => (

                                <Col md={3} key={index} style={{ marginBottom: '5%' }}>
                                    <Card className="cookie november-class" style={{ border: 'none' }} onClick={() => handleCardClick(cls.href)}>
                                        <Card.Body>
                                            <div className="image">
                                                <Card.Img src={cls.image} className="fixed-height-img" loading="lazy"/>
                                                <div className="cls-text">
                                                    <Card.Text>
                                                        <p className="cls-date">

                                                            <i className="fa-solid fa-calendar-days" style={{ color: "#e65c8c" }}></i>&nbsp;
                                                            {cls.date}
                                                        </p>
                                                    </Card.Text>
                                                    <Card.Title>
                                                    {cls.title.split('\n').map((line, i) => (
                                                                <h5 key={i}>{line}</h5>
                                                            ))}
                                                    </Card.Title>
                                                    <Card.Text>
                                                            <p className="cls-para">{cls.description}</p>
                                                           
                                                        </Card.Text>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ))
                            }
                        </Row>
                    </Container>
                </div>
                
            </div> 
            </div>
        </>
    )
}